// extracted by mini-css-extract-plugin
export default {"form":"OzIMfnp3","fields":"L9MZJyY3","preloaderWrapper":"QCcbfJ5e"};